<template>
    <b-button
        type="submit"
        class="btn-step col-12"
        variant="primary"
        squared
        :disabled="submitStatus === 'PENDING'">
        {{$t('footer.next')}} <b-icon-arrow-right aria-hidden="true"/>
    </b-button>
</template>

<script>
export default {
  name: 'CheckInFooter',
  props: {
    submitStatus: String
  },
}
</script>
